import React, { useState } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";

const Layout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "black" }}>
      {/* Header */}
      <Header onMenuClick={handleDrawerToggle} />
      
      {/* Sidebar */}
      <Sidebar mobileOpen={mobileOpen} onMobileClose={handleDrawerToggle} />
      
      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundColor: "black",
          marginTop: "130px", // Header height
          height: "calc(100vh - 130px)",
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* This is where the page content will be rendered */}
        <Box sx={{ flex: 1, padding: { xs: "16px", md: "24px" } }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;